/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaGNVertSecuredConfiguration } from '../shiva-gn-vert-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { exportExcelStationTransactions } from '../fn/transactions/export-excel-station-transactions';
import { ExportExcelStationTransactions$Params } from '../fn/transactions/export-excel-station-transactions';

@Injectable({ providedIn: 'root' })
export class SitesManagementService extends BaseService {
  constructor(config: ShivaGNVertSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `exportExcelStationTransactions()` */
  static readonly ExportExcelStationTransactionsPath = '/custom/stations/{uid}/transactions/export';

  /**
   * Export the transactions assigned to this station.
   *
   * Allows to export the station's transactions as an XLSX File
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportExcelStationTransactions()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportExcelStationTransactions$Response(params: ExportExcelStationTransactions$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportExcelStationTransactions(this.http, this.rootUrl, params, context);
  }

  /**
   * Export the transactions assigned to this station.
   *
   * Allows to export the station's transactions as an XLSX File
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportExcelStationTransactions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportExcelStationTransactions(params: ExportExcelStationTransactions$Params, context?: HttpContext): Observable<Blob> {
    return this.exportExcelStationTransactions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

}
